import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { UserPlus, Trash2 } from "lucide-react";

const ROLES = ["admin", "editor", "supervisor", "lectura"];

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "lectura" });
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/admin/users").then(r => setUsers(r.data.users));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/users", form);
      toast.success("Usuario creado");
      setForm({ name: "", email: "", password: "", role: "lectura" });
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar usuario?")) return;
    try { await api.delete(`/admin/users/${id}`); toast.success("Eliminado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div data-testid="admin-users">
      <header className="mb-8">
        <div className="label-mono mb-1">/ Usuarios</div>
        <h1 className="font-display text-4xl chrome-text">Permisos & roles</h1>
      </header>

      <div className="grid lg:grid-cols-3 gap-5">
        <form onSubmit={submit} className="glass-card chrome-border p-6 lg:col-span-1 space-y-3" data-testid="create-user-form">
          <div className="label-mono">/ Nuevo usuario</div>
          <input value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} placeholder="Nombre" required className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-2 text-sm" data-testid="user-name" />
          <input value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} type="email" placeholder="Email" required className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-2 text-sm" data-testid="user-email" />
          <input value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})} type="password" placeholder="Contraseña" required className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-2 text-sm" data-testid="user-password" />
          <select value={form.role} onChange={(e)=>setForm({...form, role: e.target.value})} className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-2 text-sm" data-testid="user-role">
            {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <button type="submit" disabled={loading} className="btn-metal w-full" data-testid="user-create"><UserPlus className="w-4 h-4" /> {loading ? "..." : "Crear"}</button>
        </form>

        <div className="lg:col-span-2 glass-card chrome-border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="label-mono text-left">
              <tr className="border-b border-white/5">
                <th className="py-3 px-4">Nombre</th><th className="py-3 px-4">Email</th><th className="py-3 px-4">Rol</th><th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id} className="border-b border-white/5">
                  <td className="py-3 px-4 text-white">{u.name}</td>
                  <td className="py-3 px-4 text-white/70">{u.email}</td>
                  <td className="py-3 px-4"><span className="px-2 py-1 rounded-full text-xs border border-cyan-400/40 bg-cyan-400/10 text-cyan-300">{u.role}</span></td>
                  <td className="py-3 px-4"><button onClick={()=>remove(u.id)} className="text-white/40 hover:text-rose-400"><Trash2 className="w-4 h-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
